import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import BlockRightImage from "../../components/BlockRightImage";
import Accordion from "../../components/Accordion";
import Modal from "../../components/Modal";
import PosgradoPagos from "../../components/PosgradoPagos";
import {
  PosgradoPostulacionFixed,
  NormativaPosgrados,
  PosgradoEscuelaNegocios,
} from "../../components/Pasos";
import ConectUs from "../../components/ConectUs";
import Block3Columns from "../../components/Block3Columns";
import BlockLeftImage from "../../components/BlockLeftImage";
import Quote from "../../components/Quote";
import Block6Columns from "../../components/Block6Columns";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";
import campo from "../../img/iconsoferta/campo.png";
import inicio from "../../img/iconsoferta/inicio.png";
import SemanasInternacionales from "../../components/SemanasInternacionales";

function MaestriaAdministracionMBA() {
  function brochure(data) {
    // Si data es un array, tomamos el primer elemento; si es un string, lo usamos directamente
    const url = Array.isArray(data) ? data[0] : data;

    // Validar que url es un string y que no está vacío
    if (typeof url !== "string" || !url.trim()) {
      return null;
    }

    return (
      <>
        <a className="button" target="_blank" rel="noreferrer" href={url}>
          Brochure del programa📕
        </a>
        <br />
      </>
    );
  }

  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            {" "}
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div className="icon200">
                    <img
                      src="https://www.utpl.edu.ec/maestrias/sites/default/files/escuela-de-negocio.png"
                      alt="utpl"
                    ></img>
                  </div>{" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                  {item.field_oferta_actual === "1" && (
                    <>
                      <PosgradoEscuelaNegocios />

                      {item?.field_enlace_postulacion && (
                        <a href={item.field_enlace_postulacion}>
                          Postula ahora
                        </a>
                      )}
                    </>
                  )}
                </>
              }
            ></BlockImageCabecera>
            <div className="graybg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/escuela-negocios">
                      UTPL Escuela de Negocios
                    </NavLink>
                    
                    <NavLink to="/mba-online">
                      Maestría en Administración de Empresas con mención en
                      Innovación
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <div className="padding oferta-icons">
                <Block6Columns
                  col1={
                    <>
                      <img src={titulo}></img>
                      <p>
                        <b>Título</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_titulo,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={modalidad}></img>
                      <p>
                        <b>Modalidad</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_modalidad,
                        }}
                      />
                    </>
                  }
                  col3={
                    <>
                      <img src={calendario}></img>
                      <p>
                        <b>Duración</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_duracion,
                        }}
                      />
                    </>
                  }
                  col4={
                    <>
                      <img src={campo}></img>
                      <p>
                        <b>Campo amplio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_campo,
                        }}
                      />
                    </>
                  }
                  col5={
                    <>
                      <img src={sale}></img>
                      <p>
                        <b>Precio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_costo_texto,
                        }}
                      />
                    </>
                  }
                  col6={
                    <>
                      <img src={inicio}></img>
                      <p>
                        <b>Fecha de inicio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_inicio,
                        }}
                      />
                    </>
                  }
                ></Block6Columns>
              </div>
            </div>
            <div className=" margin ">
              <div className="relative">
                <div className="layout8 "> {brochure(item.field_brochure)}</div>
                <div
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_pos_resolucion,
                  }}
                />{" "}
              </div>

              <div className="layout8">
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_posgrado_ingreso,
                  }}
                />

                <Modal
                  title="Ver más"
                  content={
                    <div className="lightbluebg fontsize11 padding2">
                      <div className="layout8">
                        <p>
                          Los postulantes deberán evidenciar disposición y
                          habilidades académicas iniciales acordes al nivel de
                          posgrado, que les permitan sostener el proceso
                          formativo, tales como comprensión lectora,
                          razonamiento básico, aprendizaje autónomo y manejo de
                          herramientas digitales.
                        </p>
                        <p>
                          Se espera que los postulantes demuestren motivación y
                          coherencia entre sus objetivos personales y
                          profesionales y el enfoque del programa, capacidad de
                          organización del tiempo y autorregulación académica, y
                          habilidades iniciales de pensamiento crítico para
                          enfrentar y reflexionar sobre retos académicos y
                          profesionales.{" "}
                        </p>
                        <p>
                          {" "}
                          De igual manera, los postulantes declararán su
                          trayectoria académica y/o profesional, así como la
                          formación continua y otros méritos relevantes, en
                          función de la naturaleza del programa.
                        </p>
                      </div>
                    </div>
                  }
                >
                  {" "}
                </Modal>
              </div>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo,
                    }}
                  />
                </>
              }
            ></Quote>
            <div
              className="section-perfil-egreso"
              style={{
                backgroundImage: `url(${item.field_posgrado_imagenegreso})`,
              }}
            ></div>
            <div className="layout8 margin">
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_posgrado_egreso,
                }}
              />
              <Accordion
                title="Más información"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_perfil_de_egreso_amplio,
                    }}
                  />
                }
              ></Accordion>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo2,
                    }}
                  />
                </>
              }
            ></Quote>
            <div className="layout6 ">
              {" "}
              <Accordion
                title="Malla curricular"
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_malla,
                      }}
                    />{" "}
                  </>
                }
              ></Accordion>
            </div>
            <div className=" relative margin lightbluebg">
              <BlockLeftImage
                src={item.field_imagen_requisitos}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_requisitos,
                      }}
                    />{" "}
                    {item.field_oferta_actual === "1" && (
                      <>
                        <PosgradoEscuelaNegocios />
                        {item?.field_enlace_postulacion && (
                          <a href={item.field_enlace_postulacion}>
                            Postula ahora
                          </a>
                        )}
                      </>
                    )}{" "}
                    <NormativaPosgrados></NormativaPosgrados>
                  </>
                }
              ></BlockLeftImage>{" "}
            </div>
            <div
              className="diferencia  "
              style={{
                backgroundImage: `url(${item.field_posgrado_imagenegreso})`,
              }}
            >
              <div className="bluebg padding">
                <div className="layout8">
                  <center>
                    {" "}
                    <h2>
                      ¿Qué <b>nos diferencia?</b>
                    </h2>
                  </center>
                </div>

                <Block3Columns
                  col1={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_diferencia,
                      }}
                    />
                  }
                  col2={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_diferencia2,
                      }}
                    />
                  }
                  col3={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_diferencia3,
                      }}
                    />
                  }
                ></Block3Columns>
              </div>
            </div>
            <div className=" padding2 icon400">
              <div
                className="flex col2 layout8 "
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque2,
                }}
              />{" "}
            </div>
            <SemanasInternacionales></SemanasInternacionales>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo3,
                    }}
                  />
                </>
              }
            ></Quote>
            <div className="icon300 padding lightbluebg">
              <BlockRightImage
                src={item.field_imagen1}
                content={
                  <>
                    <p className="iconsize20">📣</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
            <div className="wrapper-docente  margin">
              <div
                className="layout6"
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_docente,
                }}
              />

              <div
                className="flex-center margin"
                dangerouslySetInnerHTML={{
                  __html: item.field_docente,
                }}
              />
            </div>
          </div>
        ))}{" "}
        <Quote
          content={
            <p>
              Implementamos adaptaciones curriculares no significativas, como
              ajustes en tiempos de entrega y recursos, con el fin de garantizar
              el cumplimiento de los objetivos de aprendizaje. Estas
              adaptaciones pueden aplicarse tanto a estudiantes con discapacidad
              como a aquellos que no presentan dicha condición.
            </p>
          }
        ></Quote>
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://www.utpl.edu.ec/maestrias/services/mba-online.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        instagram="https://www.instagram.com/utplescueladenegocios"
        linkedin="https://www.linkedin.com/company/utplescueladenegocios"
        tiktok="https://www.tiktok.com/@utplescueladenegocios"
        facebook="https://www.facebook.com/utplescuelanegocios/"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default MaestriaAdministracionMBA;
